import styles from "./global-loader.module.css"

export default function GlobalLoader({
  isLoading = false,
  variant = "spinner",
  message = "Loading...",
  fullScreen = false,
}) {
  if (!isLoading) return null

  const containerClass = fullScreen ? styles.fullScreenContainer : styles.container

  return (
    <div className={containerClass}>
      <div className={styles.loadingContent}>
        {variant === "spinner" && (
          <div className={styles.spinnerWrapper}>
            <div className={styles.spinner}></div>
            <div className={styles.spinnerRing1}></div>
            <div className={styles.spinnerRing2}></div>
          </div>
        )}

        {variant === "dots" && (
          <div className={styles.dotsLoader}>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
          </div>
        )}

        {variant === "bars" && (
          <div className={styles.barsLoader}>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
          </div>
        )}

        {variant === "pulse" && (
          <div className={styles.pulseLoader}>
            <div className={styles.pulse}></div>
          </div>
        )}

        {message && <p className={styles.loadingText}>{message}</p>}
      </div>
    </div>
  )
}

export function SkeletonLoader({ count = 3, type = "card" }) {
  return (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`${styles.skeleton} ${styles[`skeleton${type}`]}`}>
          {type === "card" && (
            <>
              <div className={styles.skeletonImage}></div>
              <div className={styles.skeletonText}></div>
              <div className={styles.skeletonText}></div>
            </>
          )}
          {type === "text" && (
            <>
              <div className={styles.skeletonTextLine}></div>
              <div className={styles.skeletonTextLine}></div>
              <div className={styles.skeletonTextLine}></div>
            </>
          )}
        </div>
      ))}
    </div>
  )
}
